import React from 'react'
import {PageSectionTitle} from "../commons";
import {Grid} from "@mui/material";
import {CostAnalysisChart} from "./cost-analysis/cost-analysis-chart";

interface CostAnalysisProps {
    chartData: {
        microjobs: number[]
        apis: number[]
        commissions: number[]
    }
}

interface CostAnalysisState {

}

export class CostAnalysis extends React.Component<CostAnalysisProps, CostAnalysisState>
{
    render(){
        return (
            <>
                <PageSectionTitle title={"Analisi dei Costi"} />
                <Grid container>
                    <Grid item xs={12}>
                        <CostAnalysisChart chartData={this.props.chartData}/>
                    </Grid>
                </Grid>
            </>
        )
    }
}
